//Node imports
import { IEvent } from "@quest/adapter-interface";
import { Container, ingenuity, detectDeviceEnvironmentConstants } from "@quest/base-core";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";
import { BaseViewBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";

export class JackpotBannerView extends BaseViewBehavior {
    private jackpotPresentationMainContainer: Container;
    private jackpotsBackgroundContainer: Container;
    public triggeredJackpotContainer: Container;
    public triggeredJackpotBGContainer: Container;
    private jackpotsCharacterContainer: Container;
    public coinShowerContainerMask: any;

    /**
   * Method initializeComponents override to initialize jackpot components
   */
    protected initializeComponents(): void {
        this.jackpotPresentationMainContainer = this.getContainerByID("jackpotBannerMainContainer");
        this.jackpotsCharacterContainer = this.getContainerByID("jackpotsContainer");
        this.jackpotsBackgroundContainer = this.getContainerByID("jackpotsBackgroundContainer");
        this.coinShowerContainerMask = this.getShapeById("coinShowerContainerMask") as any;
        if (ingenuity.deviceEnv.getOrientation() !== constants.ORIENTATION.PORTRAIT) {
            this.scaleComponents();
        }
        super.initializeComponents();
    }

    /**
   * Method resize override to update resizing of jackpot banners
   */
    protected resize(evt: IEvent): void {
        super.resize(evt);
        if (ingenuity.deviceEnv.isDesktop) {
            this.y = innerHeight * SlotConstantsBehavior.HALF_CONVERTER;

        }
        else if (ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.PORTRAIT) {
            this.y = innerHeight / 2;
            this.pivot.set(ingenuity.configData.height / 2, ingenuity.configData.width / 2);
            let scale = Math.max((innerHeight / ingenuity.configData.width), (innerWidth / ingenuity.configData.height));
            this.getContainerByID("jackpotsContainer_background").scale.set(scale);
            if (ingenuity.deviceEnv.getIsIpad()) {
                this.jackpotsCharacterContainer && this.jackpotsCharacterContainer.scale.set(ingenuity.deviceEnv.getPortraitMaxScale());
            } else {
                this.jackpotsCharacterContainer && this.jackpotsCharacterContainer.scale.set(ingenuity.deviceEnv.getPortraitScale());
            }
            this.scale.set(1);
        }
        else {

            this.pivot.set(ingenuity.configData.width / 2, ingenuity.configData.height / 2);
            this.y = innerHeight * SlotConstantsBehavior.HALF_CONVERTER;

        }
        //For both Desktop & Landscape
        if (ingenuity.deviceEnv.getOrientation() !== constants.ORIENTATION.PORTRAIT) {
            const heightScale: number = innerHeight / ingenuity.configData.height;
            this.scaleComponents();
            this.scale.set(heightScale);
            this.getContainerByID("jackpotsContainer_background").scale.set(1);
        }
        this.handleAnimationInPola();
    }


    //Method to handle animation in POLA
    public handleAnimationInPola(): void {
        if (this.triggeredJackpotContainer) {
            this.allignAnimations(this.triggeredJackpotContainer.children[1]);
            this.allignAnimations(this.triggeredJackpotContainer.children[3]);
        }
        if (this.triggeredJackpotBGContainer) {
            this.allignAnimations(this.triggeredJackpotBGContainer);
        }
    }

    //Method to align jackpot banner spine
    private allignAnimations(container: Container): void {
        container && container.forEach((spine: any) => {
            spine.alpha = spine.json.orientation[ingenuity.deviceEnv.getOrientation()].alpha;
        })
    }

    //Method to scale container
    private scaleComponents(): void {
        const heightScale: number = innerHeight / ingenuity.configData.height;
        const widthScale: number = innerWidth / ingenuity.configData.width;
        if (this.jackpotsCharacterContainer) {
            if (widthScale < heightScale) {
                const finalScale: number = widthScale / heightScale;
                this.jackpotsCharacterContainer.scale.set(finalScale);
            } else {
                this.jackpotsCharacterContainer.scale.set(1);
            }
        }
    }

    public changeMeterParent(): void {
        if (this.jackpotPresentationMainContainer) {
            if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.LANDSCAPE) {
                this.jackpotsBackgroundContainer.addChild(this.jackpotsCharacterContainer);
            }
            else {
                this.jackpotsBackgroundContainer.addChild(this.jackpotsCharacterContainer);
            }
        }
    }
}